/**
 * Bundled Theme Configuration
 * 
 * Auto-generated at build time from public/UserData/wedding-theme-config.json
 * DO NOT EDIT THIS FILE MANUALLY
 * 
 * Generated at: 2026-03-06T15:16:07.612Z
 */

export const bundledThemeConfig = {
  "type": "theme",
  "colors": {
    "primary": "#8EA58C",
    "secondary": "#5C4033",
    "accent": "#BFCFBB",
    "neutral": "#D9C2A8",
    "surface": "#ffffff"
  },
  "font": "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif"
};

export default bundledThemeConfig;
